import PageDados from "../Dados"

export default function Homepage() {
  return <PageDados />
}
